import React, { useState } from 'react';
import { useEvaluationRequestUtils } from '../../../utils/useRecommendation';
import Button from '../../controls/Button';
import RadioField from '../../controls/Form/components/RadioField';
import BaseModal from '../BaseModal';

import './ReuseRecommendationModal.less';

/**
 *
 * @param {{
 *  show?:boolean;
 *  request?:import('../../../store/reducers/dashboardReducer').TEvaluationRequest;
 *  onClose?(r:boolean):void;
 *  isBusy?:boolean;
 * }} props
 * @returns {React.ReactElement}
 */
const ReuseRecommendationModal = props => {
  const { show, request, onClose, isBusy } = props;
  const evaluation = useEvaluationRequestUtils(request);

  const [selectedOption, setSelectedOption] = useState('');
  const evaluationName = evaluation.getEvaluationDisplayName().toSingleForm();
  const applicantName = evaluation.getApplicantFullName();

  const choiceOptions = [
    {
      value: '0',
      label: `No, do not use this ${evaluationName} for other requests.`,
    },
    {
      value: '1',
      label: `Yes, reuse this ${evaluationName} for all incomplete and future requests of this type from <strong>${applicantName}<strong>`,
      ariaLabel: `Yes, reuse this ${evaluationName} for all incomplete and future requests of this type from ${applicantName}`,
    },
  ];

  const primaryButtonClickHandler = () => {
    onClose?.(selectedOption === '1');
    setSelectedOption('');
  };

  /**
   *
   * @param {string} name
   * @param {string} value
   */
  const handleChoiceChanged = (name, value) => {
    setSelectedOption(value);
  };

  const modalBody = () => {
    const footerText = `You will not be able to review and edit these ${evaluationName} prior to submitting.`;
    return (
      <>
        <p tabIndex={0}>
          Would you like to automatically submit this {evaluationName} for the applicant's other programs?
        </p>
        <RadioField
          required={false}
          name="reuse"
          onChange={handleChoiceChanged}
          selectedOptionValue={selectedOption}
          options={choiceOptions}
        />
        {selectedOption === '1' ? (
          <p className="warning-message mt-2" role={'alert'}>
            <i className="far fa-exclamation-triangle" />
            <span>{footerText}</span>
          </p>
        ) : null}
      </>
    );
  };

  const renderControls = () => {
    return (
      <>
        <Button primary onClick={primaryButtonClickHandler} size="large" disabled={!selectedOption}>
          Continue
        </Button>
      </>
    );
  };

  return (
    <BaseModal
      isBusy={isBusy}
      show={show}
      modalClass={'modal-reuse-recommendation'}
      title={`Reuse this ${evaluationName} for all future requests from this applicant?`}
      body={modalBody()}
      controls={renderControls()}
    />
  );
};

export default ReuseRecommendationModal;
